function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F44",
  d: "M3.32 53.976C.19 47.918-.797 40.92.66 33.962c2.482-11.866 12.233-21.185 24.195-23.148 20.393-3.348 37.85 14.112 34.505 34.505-1.963 11.962-11.284 21.713-23.148 24.196-6.96 1.456-13.958.469-20.015-2.661l-8.323 1.998c-3.945.947-7.5-2.607-6.554-6.552l2-8.324",
  opacity: 0.2,
  transform: "translate(-159 -166) translate(0 96) translate(159 72)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.642 18C17.136 18 7 28.136 7 40.642c0 4.642 1.402 8.955 3.798 12.547l-1.987 8.283 8.283-1.99c3.592 2.397 7.905 3.801 12.548 3.801 12.505 0 22.641-10.138 22.641-22.641C52.283 28.136 42.147 18 29.642 18z",
  transform: "translate(-159 -166) translate(0 96) translate(159 72)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F44",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.623,
  d: "M29.642 18C17.136 18 7 28.136 7 40.642c0 4.642 1.402 8.955 3.798 12.547l-1.987 8.283 8.283-1.99c3.592 2.397 7.905 3.801 12.548 3.801 12.505 0 22.641-10.138 22.641-22.641C52.283 28.136 42.147 18 29.642 18zM63.56 9.2l-6.654 6.653m13.21 37.163l-5.588-1.498m9.088 2.436l-9.088-2.436m-8.218 17.89l-2.047-2.045m16.82-36.196l-5.588 1.497M42.56 0L41.06 5.588",
  transform: "translate(-159 -166) translate(0 96) translate(159 72)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#F44",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.12 23.215H2.597C1.168 23.215 0 22.059 0 20.647V10.51c0-1.412 1.168-2.567 2.596-2.567H15.12c1.427 0 2.595 1.155 2.595 2.567v10.138c0 1.412-1.168 2.568-2.595 2.568zM2.444 7.942V5.905C2.444 2.657 5.193 0 8.553 0s6.109 2.657 6.109 5.905v2.037H2.444z",
  transform: "translate(-159 -166) translate(0 96) translate(159 72) translate(21 28)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.996 14.514c0-1.268-1.094-2.296-2.443-2.296-1.35 0-2.444 1.028-2.444 2.296 0 .906.56 1.687 1.37 2.06v1.356c0 .555.484 1.008 1.074 1.008.59 0 1.073-.453 1.073-1.008v-1.355c.81-.374 1.37-1.155 1.37-2.06z",
  transform: "translate(-159 -166) translate(0 96) translate(159 72) translate(21 28)"
}))))));

var SvgLockedIcon = function SvgLockedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locked_icon.2d615331.svg";
export { ForwardRef as ReactComponent };